export default __webpack_public_path__ + "static/media/_dkg_gyn-dys-einheit_rgb.fe19ef84.svg";